/*
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-24 09:48:20
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-06-06 17:00:32
 * @FilePath: /goldenSalesMobile/src/utils/index.js
 * @Description: 公用工具类
 */
import wx from "weixin-js-sdk";
import { getUserIsAuth, getOpenId } from "@/api/user";
// 手机号正则
export const mobileReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;

// loading
import { Toast } from "vant";
export const loading = () => {
  Toast.loading({
    // mask: true, //蒙层
    duration: 0, // 持续展示 toast
    forbidClick: true, // 禁用背景点击
    loadingType: "spinner",
    message: "加载中...",
  });
};

/**
 * param 将要转为URL参数字符串的对象
 * key URL参数字符串的前缀
 * encode true/false 是否进行URL编码,默认为true
 * return URL参数字符串
 */
export function urlEncode(param, key, encode) {
  if (param === null || param === "") return "";
  var paramStr = "";
  var t = typeof param;
  if (t === "string" || t === "number" || t === "boolean") {
    if (paramStr !== "") paramStr += "&";
    paramStr += key + "=" + param;
  } else {
    for (var i in param) {
      var k =
        key == null
          ? i
          : key + (param instanceof Array ? "[" + i + "]" : "." + i);
      const rt = urlEncode(param[i], k, encode);
      if (paramStr !== "" && rt !== "") paramStr += "&";
      paramStr += rt;
    }
  }
  return paramStr;
}

/**
 * @description: 获取url后面的参数
 * @param {type} 要获取的参数名
 * @return:
 */
export function getUrlParam(name) {
  console.log("99999<<<  name  >>>99999");
  console.log(name);
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
  var r = window.location.search.substr(1).match(reg); //匹配目标参数
  console.log("99999<<<  r  >>>99999");
  console.log(r);
  if (r != null) return unescape(r[2]);
  return null; //返回参数值
}

/**
 * @description: 同步imageBaseUrl
 * @param {type}
 * @return:
 */
import { getImageToken } from "@/api/system";
export async function getImagebaseUrl() {
  // 缓存中取imageToken
  let imageToken = sessionStorage.getItem("imageToken");
  if (imageToken) {
    imageToken = JSON.parse(imageToken);
  } else {
    imageToken = await getImageToken();
    sessionStorage.setItem("imageToken", JSON.stringify(imageToken));
  }
  return imageToken.UploadUrl;
}

/**
 * @description: 判断当前时间是否在某个时间段内
 * @param date [beginDateStr] [开始时间]
 * @param date [endDateStr] [结束时间]
 * @return: Boolean
 */
export function isDuringDate(beginDateStr, endDateStr) {
  let curDate = new Date().getTime(),
    beginDate = new Date(beginDateStr.replace(/-/g, "/")).getTime(),
    endDate = new Date(endDateStr.replace(/-/g, "/")).getTime();
  if (curDate >= beginDate && curDate <= endDate) {
    return true;
  }
  return false;
}

// 对象数组根据某属性分组
export function arrayGroupBy(array, f) {
  let groups = {};
  array.forEach(function (o) {
    var group = f(o) == null ? "" : JSON.stringify(f(o));
    groups[group] = groups[group] || [];
    groups[group].push(o);
  });
  return Object.keys(groups).map(function (group) {
    return groups[group];
  });
}
// 封装storage
export const handleLocalStorage = {
  set(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  get(key) {
    return localStorage.getItem(key) &&
      localStorage.getItem(key) !== "undefined"
      ? JSON.parse(localStorage.getItem(key))
      : null;
  },
  remove(key) {
    localStorage.removeItem(key);
  },
};
// 封装sessionStorage
export const handleSessionStorage = {
  set(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  },
  get(key) {
    return sessionStorage.getItem(key) &&
      sessionStorage.getItem(key) !== "undefined"
      ? JSON.parse(sessionStorage.getItem(key))
      : null;
  },
  remove(key) {
    sessionStorage.removeItem(key);
  },
};

/** 开发环境本地模拟：强制 UseBlackGoldenUI，取值 0 / 1 */
export const DEV_MOCK_USE_BLACK_GOLDEN_UI = "DEV_MOCK_USE_BLACK_GOLDEN_UI";

function isDevelopmentEnv() {
  return process.env.NODE_ENV === "development";
}

/**
 * 设置开发环境模拟的 UseBlackGoldenUI（仅 development 生效）
 * @param {0|1|boolean} value
 */
export function setDevMockUseBlackGoldenUI(value) {
  if (!isDevelopmentEnv()) return;
  const next = value === true || value === 1 || value === "1" ? 1 : 0;
  handleSessionStorage.set(DEV_MOCK_USE_BLACK_GOLDEN_UI, next);
}

/** 读取开发环境模拟的 UseBlackGoldenUI，未设置返回 null */
export function getDevMockUseBlackGoldenUI() {
  if (!isDevelopmentEnv()) return null;
  const mock = handleSessionStorage.get(DEV_MOCK_USE_BLACK_GOLDEN_UI);
  if (mock === null || mock === undefined) return null;
  return mock === true || mock === 1 || mock === "1" ? 1 : 0;
}

/**
 * 接口返回门店数据后，按开发环境模拟参数改写 UseBlackGoldenUI。
 * 非开发环境或未设置模拟参数时原样返回。
 * @param {Object} vpnItem vpn 接口单条门店数据
 * @returns {Object}
 */
export function applyDevMockUseBlackGoldenUI(vpnItem) {
  if (!vpnItem || !isDevelopmentEnv()) return vpnItem;
  const mock = getDevMockUseBlackGoldenUI();
  if (mock === null) return vpnItem;
  if (vpnItem.SaasVpnSetting) {
    vpnItem.SaasVpnSetting.UseBlackGoldenUI = mock;
  }
  vpnItem.UseBlackGoldenUI = mock;
  return vpnItem;
}

/** 黑金 UI 子版本：1=现有黑金，2=Figma 新版主题 */
export const BLACK_GOLDEN_UI_VERSION_KEY = "BLACK_GOLDEN_UI_VERSION";
export const DEV_MOCK_BLACK_GOLDEN_UI_VERSION =
  "DEV_MOCK_BLACK_GOLDEN_UI_VERSION";

/**
 * 规范化黑金 UI 版本号，仅支持 1 / 2。
 * @param {any} value
 * @returns {1|2}
 */
export function normalizeBlackGoldenUIVersion(value) {
  const num = Number(value);
  return num === 2 ? 2 : 1;
}

/**·
 * 读取打包配置文件中的黑金 UI 默认版本（VUE_APP_BLACK_GOLDEN_UI_VERSION）。
 * 未配置或非 vlife 等渠道时默认为 1。
 * @returns {1|2}
 */
export function getBuildDefaultBlackGoldenUIVersion() {
  const envVersion = process.env.VUE_APP_BLACK_GOLDEN_UI_VERSION;
  if (envVersion != null && String(envVersion).trim() !== "") {
    return normalizeBlackGoldenUIVersion(envVersion);
  }
  return 1;
}

/**
 * 设置开发环境模拟的黑金 UI 版本（仅 development 生效）
 * @param {1|2} version
 */
export function setDevMockBlackGoldenUIVersion(version) {
  if (!isDevelopmentEnv()) return;
  const next = normalizeBlackGoldenUIVersion(version);
  handleSessionStorage.set(DEV_MOCK_BLACK_GOLDEN_UI_VERSION, next);
  handleSessionStorage.set(BLACK_GOLDEN_UI_VERSION_KEY, next);
}

/** 读取开发环境模拟的黑金 UI 版本，未设置返回 null */
export function getDevMockBlackGoldenUIVersion() {
  if (!isDevelopmentEnv()) return null;
  const mock = handleSessionStorage.get(DEV_MOCK_BLACK_GOLDEN_UI_VERSION);
  if (mock === null || mock === undefined) return null;
  return normalizeBlackGoldenUIVersion(mock);
}

/**
 * 解析当前应使用的黑金 UI 版本（v1 / v2）。
 * 仅在接口开启黑金（UseBlackGoldenUI）后生效；子版本来自打包配置，不由接口 BlackGoldenUIVersion 决定。
 * 优先级：开发模拟 > 路由 query（调试）> session 缓存 > 打包配置 VUE_APP_BLACK_GOLDEN_UI_VERSION
 * @param {Object} [source] 可含 blackUiVersion / BlackGoldenUIVersion 的路由 query 调试入参
 * @returns {1|2}
 */
export function resolveBlackGoldenUIVersion(source) {
  const mock = getDevMockBlackGoldenUIVersion();
  if (mock !== null) return mock;

  const queryVersion =
    source &&
    (source.blackUiVersion != null
      ? source.blackUiVersion
      : source.BlackGoldenUIVersion);
  if (queryVersion != null) {
    return normalizeBlackGoldenUIVersion(queryVersion);
  }

  const cached = handleSessionStorage.get(BLACK_GOLDEN_UI_VERSION_KEY);
  if (cached != null) return normalizeBlackGoldenUIVersion(cached);
  return getBuildDefaultBlackGoldenUIVersion();
}

/** 接口是否开启黑金点餐 UI */
export function isUseBlackGoldenUIEnabled(vpnItem) {
  if (!vpnItem) return false;
  const setting = vpnItem.SaasVpnSetting || vpnItem;
  const flag =
    setting.UseBlackGoldenUI != null
      ? setting.UseBlackGoldenUI
      : vpnItem.UseBlackGoldenUI;
  return flag === true || flag === 1 || flag === "1";
}

/**
 * 接口返回后：仅当 UseBlackGoldenUI 开启时，按打包配置写入黑金子版本。
 * @param {Object} vpnItem
 * @returns {Object}
 */
export function applyBlackGoldenUIVersion(vpnItem) {
  if (!vpnItem) return vpnItem;
  if (!isUseBlackGoldenUIEnabled(vpnItem)) {
    handleSessionStorage.remove(BLACK_GOLDEN_UI_VERSION_KEY);
    return vpnItem;
  }
  const version = resolveBlackGoldenUIVersion();
  if (vpnItem.SaasVpnSetting) {
    vpnItem.SaasVpnSetting.BlackGoldenUIVersion = version;
  }
  vpnItem.BlackGoldenUIVersion = version;
  handleSessionStorage.set(BLACK_GOLDEN_UI_VERSION_KEY, version);
  return vpnItem;
}

/** 按黑金 UI 版本返回点餐页路由 name */
export function getBlackMicropointRouteName(source) {
  return resolveBlackGoldenUIVersion(source) === 2
    ? "BlackMicropointV2"
    : "BlackMicropoint";
}

/** 提交订单页 */
export function getBlackCurrentConsumeRouteName(source) {
  return resolveBlackGoldenUIVersion(source) === 2
    ? "BlackCurrentConsumeV2"
    : "BlackCurrentConsume";
}

/** 我的订单 / 消费记录页 */
export function getBlackRecordConsumeRouteName(source) {
  return resolveBlackGoldenUIVersion(source) === 2
    ? "BlackRecordConsumeV2"
    : "BlackRecordConsume";
}

/** 下单成功页 */
export function getBlackPlaceOrderSuccessRouteName(source) {
  return resolveBlackGoldenUIVersion(source) === 2
    ? "BlackPlaceOrderSuccessV2"
    : "BlackPlaceOrderSuccess";
}

/** 选择用餐人数页 */
export function getBlackInputPeopleNumRouteName(source) {
  return resolveBlackGoldenUIVersion(source) === 2
    ? "BlackInputPeopleNumV2"
    : "BlackInputPeopleNum";
}

// 封装设置有效期的storage
export const handleTimeLocalStorage = {
  set(key, value, expire) {
    let obj = {
      data: value,
      time: Date.now(),
      expire: expire,
    };
    localStorage.setItem(key, JSON.stringify(obj));
  },
  get(key) {
    let val = localStorage.getItem(key);
    if (!val) {
      return val;
    }
    val = JSON.parse(val);
    if (Date.now() - val.time > val.expire) {
      localStorage.removeItem(key);
      return null;
    }
    return val.data;
  },
};
export function handleScanCode(scanObj, successCallback, failCallback) {
  wx.ready(() => {
    wx.scanQRCode({
      desc: "scanQRCode desc",
      needResult: (scanObj && scanObj.needResult) || 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果
      scanType: ["qrCode", "barCode"],
      success: (res) => {
        if (successCallback) successCallback(res);
      },
      fail: (err) => {
        if (failCallback) failCallback(err);
      },
    });
  });
}
export const dateFormat = (d, pattern = "yyyy-MM-dd") => {
  const y = d.getFullYear().toString(),
    o = {
      M: d.getMonth() + 1, //month
      d: d.getDate(), //day
      h: d.getHours(), //hour
      m: d.getMinutes(), //minute
      s: d.getSeconds(), //second
    };
  pattern = pattern.replace(/(y+)/gi, function (a, b) {
    return y.substr(4 - Math.min(4, b.length));
  });
  for (const i in o) {
    pattern = pattern.replace(new RegExp("(" + i + "+)", "g"), function (a, b) {
      return o[i] < 10 && b.length > 1 ? "0" + o[i] : o[i];
    });
  }
  return pattern;
};

//获取当前时间前n天的日期
export const getCurrentPreviousDay = (day = 1) => {
  let date = new Date();
  var oneweekdate = new Date(date.getTime() - day * 24 * 3600 * 1000);
  console.log(oneweekdate);
  return dateFormat(oneweekdate);
};
export function handleAuthUserInfo(callback) {
  getUserIsAuth().then((res) => {
    if (!res) {
      //未授权
      // snsapi_userinfo:非静默授权，第一次有弹框,snsapi_base:静默授权，没有弹窗
      const code = getUrlParam("code"); // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接获取openId
      // const code = this.$route.query.code // 注意：this.$route.query.code是无法获取到code的：http://golden.ticket.goldenyun.cn/?code=061Slqge2CSNNI0Xhsie2nhGge2Slqgk&state=1#/sales/goods-list
      const appId = handleLocalStorage.get("appId");
      const componentAppId = handleLocalStorage.get("componentAppId");
      const codeData = handleLocalStorage.get("loginCode");
      const local = window.location.href;
      console.log(code);
      console.log(codeData);
      if (code == null || code === "" || (codeData && codeData == code)) {
        handleLocalStorage.remove("loginCode");
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          appId +
          "&redirect_uri=" +
          encodeURIComponent(local) +
          "&response_type=code&scope=snsapi_base&state=1&component_appid=" +
          componentAppId +
          "#wechat_redirect";
      } else {
        console.log("授权后调用接口，获取用户头像等信息");
        getOpenId(code).then((res) => {
          if (callback) callback();
        });
      }
    } else {
      console.log(8888888888);
      if (callback) callback();
    }
  });
}
